'use client';

import { ReactNode, useState } from 'react';
import ModalFormMC from '../Modal/ModalMC';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface WorkWithUsBlockProps {
  id?: string;
  title?: ReactNode | SerializedEditorState;
  text?: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  btnText?: string;
  formatList?: {
    icon: string;
    title: ReactNode | SerializedEditorState;
  }[];
}

export default function WorkWithUsBlock({
  id,
  title,
  text,
  subtitle,
  btnText,
  formatList,
}: WorkWithUsBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  return (
    <>
      <div
        id={id}
        data-meta="WorkWithUsBlock"
        className="container mx-auto px-4 sm:px-6 lg:px-8 my-24"
      >
        <CustomRichText
          data={title}
          tag="h2"
          className="text-3xl text-center font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
        />
        <CustomRichText
          data={text}
          tag="div"
          className="mt-2 text-md lg:text-xl lg:leading-8 text-white text-center"
        />
        <CustomRichText
          data={subtitle}
          tag="div"
          className="mt-4 text-lg text-center font-bold tracking-tight text-white sm:text-3xl mb-4 sm:mb-8"
        />

        <div className="flex flex-col lg:flex-row lg:flex-wrap mt-2 lg:mt-8 lg:gap-8 gap-4">
          {formatList &&
            formatList.map((item, index) => (
              <div key={index} className={`flex flex-col flex-1 p-4 bg-white rounded-3xl`}>
                <div className="p-4">
                  <p className="font-bold text-green-100 text-6xl mb-4">{item.icon}</p>
                  <div className="mb-4">
                    <CustomRichText data={item.title} tag="div" className="text-xl font-bold" />
                  </div>
                </div>
              </div>
            ))}
        </div>
        <div className="flex justify-center mt-8">
          <button
            onClick={openForm}
            className={`custom-gradient-green-btn rounded-full px-8 py-2.5 text-center text-md font-fixel font-bold text-white shadow-sm focus-visible:outline`}
          >
            {btnText}
          </button>
        </div>
      </div>
      {isFormOpen && (
        //works only with marketing in CRM
        <ModalFormMC
          closeForm={closeForm}
          btnMeta={{
            tag: 'партнерська-програма',
          }}
          color={'green'}
        />
      )}
    </>
  );
}
